import React from 'react'
import Sidebar from '../../../Sidebar'
import Navbar from '../../../Navbar'

const VoterRegistStart = () => {
  return (
    <>
      <Sidebar/>
        <div className="main">
          <div className="topbar">
            <Navbar title="Voter Registration Start"/>
          </div>
        </div>
    </>
  )
}

export default VoterRegistStart
